import Logger from "../utils/Logger";

export default function (name: string) {
	return new Logger(name);
}
